{
  "layer_dwg": "layer as DWG",
  "layer_kml": "layer as KML",
  "drawing_units": "Drawing units",
  "coordinate_system": "Coordinate system",
  "advanced_rebase_options": "Advanced rebase options",
  "source_latitude": "Source latitude",
  "source_longitude": "Source longitude",
  "target_x": "Target X",
  "target_y": "Target Y",
  "target_rotation": "Target rotation (degrees)",
  "export_dwg": "Export DWG",
  "route_convert_line": "Convert to Line",
  "route_convert_confirmation": {
    "title": "Convert route to line",
    "message": "Are you sure you want to convert this route to a line? This action cannot be undone."
  },
  "styles": {
    "lineTypes": {
      "dotted": "Dotted",
      "smallDash": "Small dashed",
      "largeDash": "Large dashed"
    }
  },
  "no_copy_empty_group": "Cannot copy: Selection contains no layers",
  "map_group_status": {
    "title": "Group layers/groups",
    "explain": "Group layers and other groups together",
    "nested_level": "Groups can only be 3 levels deep",
    "parent": "Items can not be in different groups",
    "amount": "Select at least one item to enable grouping",
    "type": "Selection must not contain map objects",
    "loading": "Wait for map to finish loading",
    "permissions": "'Full Access' permission on plan required to enable grouping"
  },
  "map_unlink_status": {
    "title": "Unlink layers",
    "explain": "Detaches and copies layers from their original plan",
    "amount": "Select at least one linked layer to enable unlinking layers",
    "type": "Selection must only contain linked layers",
    "loading": "Wait for map to finish loading",
    "permissions": "'Edit' permission on plan required to unlink layers"
  },
  "copy_status": {
    "title": "Copy layers/groups",
    "explain": "Makes a copy of the selected layers and groups",
    "amount": "Select at least one layer to enable copying layers",
    "type": "Selection must only contain layers and groups",
    "loading": "Wait for map to finish loading",
    "permissions": "'Edit' permission on plan required to copy layers and groups"
  },
  "map_delete_status": {
    "title": "Delete layers/groups",
    "explain": "Deletes the selected layers and groups",
    "amount": "Select at least one layer or group to enable deleting",
    "type": "Selection must only contain layers and groups",
    "loading": "Wait for map to finish loading",
    "permissions": "'Admin' permission on layers required to delete layers and groups"
  },
  "mapBackgroundError": {
    "title": "Map background unavailable",
    "part1": "We couldn't load the",
    "part2": "background, so we switched to a different one. Please try",
    "part3": "again later."
  },
  "qrCode": {
    "copySuccess": "QR code copied to clipboard",
    "copyError": {
      "title": "Failed to copy QR code",
      "message": "Please try again or use the download option"
    },
    "downloadSuccess": {
      "title": "QR code downloaded",
      "message": "Check your downloads folder"
    },
    "downloadError": {
      "title": "Failed to download QR code",
      "message": "Please try again"
    }
  },
  "splitLines": {
    "title": "Split line",
    "selectMapObject": "Select a single line to split",
    "lockedLayer": "Cannot split line: layer is locked",
    "linesOnly": "Only line objects can be split",
    "fixedShapes": "Cannot split fixed shape lines",
    "drawing": "Cannot split line while drawing",
    "action": "Click to split line",
    "confirmMessage": "Are you sure you want to split this line? This action cannot be undone.",
    "tooltipStart": "From start",
    "tooltipEnd": "To end"
  }
}